import CustomHeaderTitle from "../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../components/HeaderBread";
import ShipCurrencymasterInput from "../../components/ShipCurrencymasterInput/ShipCurrencymasterInput";
import Layout from "../../Layout";

const CreateSailingDate = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Currency",
      route: "/shore/mobile-masters/sailing_currency",
    },
    {
      title: "Add Currency",
      route: "/shore/mobile-masters/sailing_currency/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Currency"}>
      <CustomHeaderTitle title={"Create Currency"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Currency"}
      ></HeaderBread>
      <ShipCurrencymasterInput newsletter={{}} />
    </Layout>
  );
};

export default CreateSailingDate;
